import { useState } from "react";
import styles from "./ProductSubmission.module.scss";
import BackButton from "../../../../../components/common/BackButton/BackButton";
import { Stepper } from "react-form-stepper";
import ProductSelection from "./ProductSelection/ProductSelection";
import PriceAdjustment from "./PriceAdjustment/PriceAdjustment";
import Submission from "./Submission/Submission";

const ProductSubmission = () => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    { label: "Product Selection" },
    { label: "Price Adjustment" },
    { label: "Submission" },
  ];

  const handleClick = () => {
    if (activeStep < 2) {
      setActiveStep(activeStep + 1);
    }
  };

  return (
    <div className={styles.mainContainer}>
      <BackButton />
      <div className={styles.submissionContainer}>
        <Stepper
          style={{ width: "100%" }}
          steps={steps}
          activeStep={activeStep}
          connectorStateColors={true}
          connectorStyleConfig={{
            completedColor: "#FBBD34",
            activeColor: "#FBBD34",
            disabledColor: "#D9D9D9",
          }}
          styleConfig={{
            activeBgColor: "#FBBD34",
            completedBgColor: "#FBBD34",
            inactiveBgColor: "#D9D9D9",
            activeTextColor: "#111",
            completedTextColor: "#222",
            inactiveTextColor: "#444",
            circleFontSize: "0",
          }}
        />

        {activeStep === 0 && <ProductSelection handleClick={handleClick} />}
        {activeStep === 1 && <PriceAdjustment handleClick={handleClick} />}
        {activeStep === 2 && <Submission handleClick={handleClick} />}

      </div>
    </div>
  );
};

export default ProductSubmission;